import {
    EpgProgram,
    RBEditorial,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import findCatchupTechnical from './findCatchupTechnical';

function getCatchupStream(
    program: EpgProgram | RBProgram | VodEditorial | undefined,
) {
    const cuTechnical = findCatchupTechnical(
        (program as RBProgram)?.editorial?.technicals ||
            (program as RBEditorial)?.technicals,
    );

    if (cuTechnical) {
        return cuTechnical.media.AV_PlaylistName.uri;
    }

    return '';
}

export default getCatchupStream;
